import React from 'react';
import { Box, Typography } from '@mui/material';

const VariantColorMap = {
    primary: '#0d4a63',  // blue
    secondary: '#8b4513',  // brown
    success: '#4caf50',  // green
};

export interface DashboardTileProps {
    icon: React.ReactNode;
    title: string;
    subtitle?: string;
    onClick: () => void;
    variant?: 'primary' | 'secondary';
}

export const DashboardTile: React.FC<DashboardTileProps> = ({ 
    icon, title, subtitle, onClick, variant = 'primary'
}) => {
    const bgColor = VariantColorMap[variant];
    const hoverColor = VariantColorMap[variant];
    return (
        <Box
            onClick={onClick}
            sx={{
                backgroundColor: bgColor,
                borderRadius: '12px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                minHeight: '200px',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                '&:hover': {
                    backgroundColor: hoverColor,
                    transform: 'translateY(-4px)',
                    boxShadow: '0 8px 16px rgba(0,0,0,0.15)',
                },
            }}
        >
            {icon && (
                <Box sx={{ mb: 2 }}>
                    {icon}
                </Box>
            )}
            <Typography
                sx={{
                    color: 'white',
                    fontSize: '20px',
                    fontWeight: 700,
                    textAlign: 'center',
                    fontFamily: "'Proxima Nova', sans-serif",
                    letterSpacing: '0.00938em',
                }}
            >
                {title}
            </Typography>
            {subtitle && (
                <Typography
                    sx={{
                        color: 'white',
                        fontSize: '18px',
                        fontWeight: 400,
                        textAlign: 'center',
                        fontFamily: "'Proxima Nova', sans-serif",
                    }}
                >
                    {subtitle}
                </Typography>
            )}
        </Box>
    );
};

export interface DashboardButtonProps {
    title: string | React.ReactNode;
    onClick: () => void;
    icon?: React.ReactNode | null;
    variant?: 'primary' | 'secondary' | 'success';
    padding?: string;
    disabled?: boolean;
};
export const DashboardButton: React.FC<DashboardButtonProps> = ({
    title, onClick, icon, variant = 'primary', padding, disabled = false
}) => {
    const bgColor = VariantColorMap[variant];
    const hoverColor = VariantColorMap[variant];
    return (
        <Box onClick={onClick}
            sx={{
                backgroundColor: bgColor,
                borderRadius: '16px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                minHeight: '51px',
                minWidth: '50px',
                padding: padding || '5px 7px',
                '&:hover': {
                    backgroundColor: hoverColor,
                    transform: 'translateY(-4px)',
                    // boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
                },
                opacity: disabled ? 0.5 : 1,
                pointerEvents: disabled ? 'none' : 'auto',
            }}
        >
            <Typography sx={{
                color: 'white',
                fontSize: '22px',
                fontWeight: 500,
                textAlign: 'center',
                fontFamily: "'Proxima Nova', sans-serif",
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {icon} <span style={{ marginLeft: icon ? '10px' : '0' }}>{title}</span>
                </Box>
            </Typography>
        </Box>
    );
};
